import { render, staticRenderFns } from "./subscription-upgrade-modal.vue?vue&type=template&id=5906d094"
import script from "./subscription-upgrade-modal.vue?vue&type=script&lang=js"
export * from "./subscription-upgrade-modal.vue?vue&type=script&lang=js"
import style0 from "./subscription-upgrade-modal.vue?vue&type=style&index=0&id=5906d094&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/subsapp-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5906d094')) {
      api.createRecord('5906d094', component.options)
    } else {
      api.reload('5906d094', component.options)
    }
    module.hot.accept("./subscription-upgrade-modal.vue?vue&type=template&id=5906d094", function () {
      api.rerender('5906d094', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/club-billing/subscription-upgrade-modal/subscription-upgrade-modal.vue"
export default component.exports